/**
 * Force one Arabic currency label (ر.س) on /ar-sa.
 *
 * Mixed labels usually come from Weglot translating SAR/SR/"Saudi Riyal"
 * differently per node (ريال / ريـال / ريال سعودي) while Liquid/JS may
 * already output ر.س — this normalizes every variant to ر.س.
 */
(function () {
  var ARABIC_CURRENCY = 'ر.س';

  // English shop formats + Weglot Arabic variants of the currency name
  var CURRENCY_LABEL_RE =
    /\bSAR\b|\bSR\b|Saudi\s+Riyals?|Saudi\s+Riyal|ريال\s*سعودي|ريـال|ريال|ر\s*\.\s*س\.?/gi;

  function isArabicPage() {
    if (typeof window.dptIsArabic === 'function') return window.dptIsArabic();
    var path = (window.location.pathname || '').toLowerCase();
    return (
      path.indexOf('/ar-sa') !== -1 ||
      document.documentElement.getAttribute('dir') === 'rtl' ||
      (document.documentElement.getAttribute('lang') || '').indexOf('ar') === 0
    );
  }

  function toArabicCurrency(str) {
    if (str == null) return str;
    return String(str).replace(CURRENCY_LABEL_RE, ARABIC_CURRENCY);
  }

  function localizeMoneyFormats() {
    if (window.theme && window.theme.settings) {
      var settings = window.theme.settings;
      if (settings.money_with_currency_format) {
        settings.money_with_currency_format = toArabicCurrency(settings.money_with_currency_format);
      }
      if (settings.money_format) {
        settings.money_format = toArabicCurrency(settings.money_format);
      }
    }

    if (window.Shopify) {
      if (Shopify.money_format) {
        Shopify.money_format = toArabicCurrency(Shopify.money_format);
      }
      if (Shopify.money_with_currency_format) {
        Shopify.money_with_currency_format = toArabicCurrency(Shopify.money_with_currency_format);
      }
      if (typeof Shopify.formatMoney === 'function' && !Shopify.formatMoney.__dptArabicWrapped) {
        var shopifyFormatMoney = Shopify.formatMoney.bind(Shopify);
        Shopify.formatMoney = function (cents, format) {
          return toArabicCurrency(shopifyFormatMoney(cents, format ? toArabicCurrency(format) : format));
        };
        Shopify.formatMoney.__dptArabicWrapped = true;
      }
    }
  }

  function wrapFormatMoney() {
    if (typeof window.formatMoney !== 'function' || window.formatMoney.__dptArabicWrapped) {
      return;
    }
    var original = window.formatMoney;
    window.formatMoney = function (cents, format) {
      var out = original.call(this, cents, format ? toArabicCurrency(format) : format);
      return toArabicCurrency(out);
    };
    window.formatMoney.__dptArabicWrapped = true;
  }

  function replaceInTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var value = node.nodeValue;
    if (!value || value.length < 2) return;
    if (
      value.indexOf('SAR') === -1 &&
      value.indexOf('SR') === -1 &&
      value.indexOf('ريال') === -1 &&
      value.indexOf('ر.س') === -1 &&
      value.indexOf('Riyal') === -1 &&
      value.indexOf('Riyals') === -1
    ) {
      return;
    }
    node.nodeValue = toArabicCurrency(value);
  }

  function shouldSkipElement(el) {
    if (!el || !el.tagName) return true;
    var tag = el.tagName;
    return tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA' || tag === 'CODE';
  }

  function walk(root) {
    if (!root) return;

    if (root.nodeType === 3) {
      replaceInTextNode(root);
      return;
    }

    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) {
      return;
    }

    if (root.nodeType === 1 && shouldSkipElement(root)) {
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || shouldSkipElement(parent)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var current;
    while ((current = walker.nextNode())) {
      replaceInTextNode(current);
    }
  }

  function applyArabicCurrency(root) {
    if (!isArabicPage()) return;
    localizeMoneyFormats();
    wrapFormatMoney();
    walk(root || document.body);
  }

  function initObserver() {
    if (!document.body || window.__dptArabicCurrencyObserver) return;

    var scheduled = false;
    var pendingNodes = [];

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'characterData') {
          pendingNodes.push(mutation.target);
        } else if (mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            pendingNodes.push(mutation.addedNodes[j]);
          }
        }
      }

      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (!isArabicPage()) {
          pendingNodes = [];
          return;
        }
        var nodes = pendingNodes;
        pendingNodes = [];
        for (var k = 0; k < nodes.length; k++) {
          walk(nodes[k]);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.__dptArabicCurrencyObserver = observer;
  }

  function init() {
    if (!isArabicPage()) return;
    applyArabicCurrency(document.body);
    initObserver();
  }

  window.dptApplyArabicCurrency = applyArabicCurrency;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
